import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from "@mui/material/colors";

/**
 * Gets a color based on the given string
 *
 * @param   {string}  string:   The string to base the color on
 *
 * @return {{ colorObject, color }}    A MaterialUI color object and a complementary text color
 */
export default function useColor(string, color) {
  const colors = [
    red,
    pink,
    purple,
    deepPurple,
    indigo,
    blue,
    lightBlue,
    cyan,
    teal,
    green,
    lightGreen,
    lime,
    yellow,
    amber,
    orange,
    deepOrange,
    brown,
    grey,
    blueGrey,
  ];
  let color_id = 0;
  let i = 0;

  if (color) {
    color_id = colors.findIndex((_color) => {
      return _color[500] === color;
    });

    if (color_id === -1) {
      return { background: "#fff", color: "#000" };
    }
  } else {
    while (i < string?.length) {
      color_id += string.charCodeAt(i);
      i += 4;
    }

    color_id = Math.round(color_id % colors.length);
  }

  const background = colors[color_id];
  const textColor =
    [lime[500], yellow[500], amber[500], orange[500], lightGreen[500], grey[500]].indexOf(background[500]) >= 0
      ? "#000"
      : "#fff";

  return { background, color: textColor };
}
